import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

interface Props {
  comic: Comic;
  active: boolean;
  onSelect: () => void;
}

export default function HeroSlideCard({ comic, active, onSelect }: Props) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-label={`切换到《${comic.title}》`}
      className={`relative w-[132px] shrink-0 rounded-lg overflow-hidden border transition-all duration-300 cursor-pointer ${
        active ? "border-accent-400 scale-100" : "border-background-700/70 opacity-65 hover:opacity-100"
      }`}
    >
      <div className="w-[132px] h-[92px]">
        <img src={comic.cover} alt={`《${comic.title}》封面缩略图`} className="w-full h-full object-cover object-top" />
      </div>
      <span className="block px-2 py-1.5 text-left text-[11px] text-foreground-200 truncate bg-background-950/85">
        {comic.title}
      </span>
      {active && <span className="absolute top-0 left-0 w-full h-0.5 bg-accent-400" />}
    </button>
  );
}

export function HeroSlideMeta({ comic }: { comic: Comic }) {
  return (
    <div className="min-w-0">
      <Link
        to={`/detail/${comic.id}`}
        className="inline-flex items-center gap-1.5 h-7 px-2.5 rounded-md bg-accent-500/15 border border-accent-500/40 text-accent-300 text-[11px] font-label hover:bg-accent-500/25 transition-colors whitespace-nowrap"
      >
        <i className="ri-award-line" />
        本期焦点 · {comic.score.toFixed(1)} 分
      </Link>
    </div>
  );
}